const breakpoints = {
  xs: {
    maxWidth: 575.98,
  },
  sm: {
    minWidth: 576,
    maxWidth: 767.98,
  },
  md: {
    minWidth: 768,
    maxWidth: 991.98,
  },
  lg: {
    minWidth: 992,
    maxWidth: 1199.98,
  },
  xl: {
    minWidth: 1200,
  },
};

export default breakpoints;
